import React from "react";

const Services = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      {/* Category Blocks */}
      

      {/* Original Services Sections */}
      <section className="static-sections py-3 bg-white" id="curtain">
        <div className="container">
          {/* Section 1 */}
          <div className="row align-items-center mb-5">
            <div className="col-lg-6">
              <h1 className="display-4 text-theme-dark">Curtains & Blinds Customization</h1>
              <p className="lead text-theme-dark">
                At Elly Decor, we specialize in made-to-measure curtains and blinds that perfectly complement your interiors. From premium fabrics to expert stitching, every piece is crafted for elegance and durability. Choose from ripplefold, pleated, or blackout options to suit your lifestyle. Our team ensures precise measurements, professional stitching, and flawless finishing, giving your windows a refined look. Whether you prefer classic drapes or modern blinds, we create customized solutions that blend seamlessly with your décor.
              </p>
              
            </div>
            <div className="col-lg-6">
              <img src="/images/product/prd1.webp" alt="Elly Decor Display" className="img-fluid rounded" />
            </div>
          </div>

          {/* Section 2 */}
          <div className="row align-items-center mb-5 mt-2" >
            <div className="col-lg-6">
              <img src="/images/product/prd2.webp" alt="Wallpaper Fabrics" className="img-fluid rounded" />
            </div>
            <div className="col-lg-6">
              <h2 className="fw-bold mb-3 text-theme-dark">Wallpaper Selection & Installation</h2>
              <p className="mb-4 text-theme-dark">
                Transform your walls into works of art with our premium wallpaper solutions. Elly Decor offers an extensive range of patterns, textures, and finishes — from subtle pastels to bold designer prints. Our experts assist in selection and provide professional installation, ensuring a seamless look without bubbles or imperfections. Designed to be durable, easy to maintain, and timelessly stylish, our wallpapers are perfect for living rooms, bedrooms, offices, and hospitality spaces.
              </p>
              
            </div>
          </div>

          {/* Section 3 */}
          <div className="row align-items-center mb-5 mt-2" id="commericial">
            <div className="col-lg-6">
              <h2 className="fw-bold mb-3 text-theme-dark">Cushions & Throws Styling</h2>
              <p className="mb-4 text-theme-dark">
                Cushions and throws are the final touches that complete a room. Elly Decor offers curated collections of soft furnishings that add depth, warmth, and character to your spaces. Our service includes helping you choose the right sizes, fabrics, and patterns to enhance sofas, chairs, and beds. From elegant solids to designer prints, we ensure your cushions and throws complement your overall décor theme perfectly.
              </p>
              
            </div>
            <div className="col-lg-6">
              <img src="/images/product/prd3.webp" alt="Home Makeover" className="img-fluid rounded" />
            </div>
          </div>

          {/* Section 4 */}
          <div className="row align-items-center mb-5 mt-2" id="makeover">
            <div className="col-lg-6">
              <img src="/images/product/prd4.webp" alt="Commercial Decor" className="img-fluid rounded" />
            </div>
            <div className="col-lg-6">
              <h1 className="display-4 text-theme-dark">Interior Styling Support</h1>
              <p className="lead text-theme-dark">
                Not sure what suits your space best? Our team provides expert styling support to help you choose fabrics, colors, and furnishings that bring your vision to life. From concept to execution, we ensure every element is harmonized to achieve a luxurious, cohesive look.
              </p>
              
            </div>
          </div>

          {/* Section 5 */}
          <div className="row align-items-center mb-5 mt-2 impSec" id="wallpaper">
            <div className="col-lg-6">
              <h2 className="fw-bold mb-3 text-theme-dark">Home Consultation</h2>
              <p className="mb-4 text-theme-dark">
                Elly Decor offers personalized home consultations, where our experts visit your space, understand your requirements, and suggest the best furnishing solutions. This service ensures you get tailor-made recommendations suited to your style, budget, and lifestyle.
              </p>
              
            </div>
            <div className="col-lg-6">
              <img src="/images/product/prd5.webp" alt="Wallpaper" className="img-fluid rounded" />
            </div>
          </div>

          {/* Section 6 */}
          <div className="row align-items-center mb-5 mt-2" id="makeover">
            <div className="col-lg-6">
              <img src="/images/product/prd4.webp" alt="Commercial Decor" className="img-fluid rounded" />
            </div>
            <div className="col-lg-6">
              <h1 className="display-4 text-theme-dark">Installation & Fitting Services</h1>
              <p className="lead text-theme-dark">
                Our services go beyond product sales — we provide professional installation for curtains, blinds, and wallpapers. With attention to detail, our team ensures a flawless finish that enhances your interiors instantly.
              </p>
              
            </div>
          </div>

          {/* Section 7 */}
          <div className="row align-items-center mb-5 mt-2 impSec" id="wallpaper">
            <div className="col-lg-6">
              <h2 className="fw-bold mb-3 text-theme-dark">Designer & Contractor Partnerships</h2>
              <p className="mb-4 text-theme-dark">
                Elly Decor partners with architects, interior designers, and contractors to supply premium furnishing products for residential and commercial projects. With bulk supply, custom solutions, and dedicated support, we make every collaboration seamless.
              </p>
              
            </div>
            <div className="col-lg-6">
              <img src="/images/product/prd5.webp" alt="Wallpaper" className="img-fluid rounded" />
            </div>
          </div>

        </div>
      </section>

      {/* Contact Section */}
      <section className="py-1 contactSection" id="contact">
        <div className="container text-center">
          <h6 className="text-uppercase text-theme-light">Get in Touch</h6>
          <h2 className="fw-bold mb-1 text-theme-light">Contact Elly Decor</h2>
          <p className="mb-4 text-theme-light">
            We are here to assist you with all your home furnishing needs. Reach out to us anytime!
          </p>

          <div className="row text-start">
            <div className="col-lg-4 mb-4 text-center">
              <span className="h1Icon"><i className="fas fa-envelope"></i></span>
              <h4 className="text-theme-light">Email Us</h4>
              <p className="text-theme-light">
                For inquiries, please email us at{" "}
                <a href="mailto:info@ellydecor.com" className="text-theme-light">
                  info@ellydecor.com
                </a>
                . We aim to respond within 24 hours.
              </p>
            </div>
            <div className="col-lg-4 mb-4 text-center">
              <span className="h1Icon"><i className="fas fa-phone-alt"></i></span>
              <h4 className="text-theme-light">Call Us</h4>
              <p className="text-theme-light">
                You can reach us at <strong>+91 98214 95696</strong>. Our team is available to assist you during business hours.
              </p>
            </div>
            <div className="col-lg-4 mb-4 text-center">
              <span className="h1Icon"><i className="fas fa-map-marker-alt"></i></span>
              <h4 className="text-theme-light">Visit Us</h4>
              <p className="text-theme-light">
                Come see us at our store located at{" "}
                <strong>Shop No. 2, Block A, CLR Complex, Sector 149, Noida, Uttar Pradesh 201310, India</strong>.
                We look forward to welcoming you!
              </p>
            </div>
          </div>
        </div>
      </section>
      <style jsx>{`
        .service-block {
          position: relative;
          overflow: hidden;
          background: #02132f;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .service-block:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 25px rgba(0, 0, 0, 0.25);
        }

        /* Continuous shining animation */
        .service-block::before {
          content: "";
          position: absolute;
          top: 0;
          left: -150%;
          width: 50%;
          height: 100%;
          background: linear-gradient(
            120deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.2) 50%,
            rgba(255, 255, 255, 0) 100%
          );
          transform: skewX(-25deg);
          animation: shineMove 3s linear infinite;
        }

        @keyframes shineMove {
          0% {
            left: -150%;
          }
          100% {
            left: 150%;
          }
        }

        @media (max-width: 768px) {
          .service-block {
            margin-bottom: 20px;
          }
        }
      `}</style>
    </>
  );
};

export default Services;
